import { useState, useEffect } from "react";
import VerificationLayout from "../../components/verification/VerificationLayout.jsx";
import StatusBox from "../../components/verification/StatusBox.jsx";
import PatientDetails from "../../components/verification/PatientDetails.jsx";
import { useSession, getSession, clearSession } from "@/hooks/useSession";
import State, { STATE, CurrentStudyState } from "@state";
import navigationService from "@services/navigation.service";
import QrController from "@/network/controllers/qr.controller.js";
import { useNavigate } from "react-router-dom";

import Button from "../../components/ui/Button.jsx";
import UserController from "@network/controllers/user.controller";
import ParticipantController from "@network/controllers/participant.controller";
import { v4 as uuidv4 } from "uuid";
import { Loader2 } from "lucide-react";
import { REDIRECT_AFTER_LOGIN } from "@/state/states/LoginFlowState.js";
import LoginFlowState from "@/state/states/LoginFlowState.js";


export default function ConsentUpToDate() {
  const [selectedMilestone, setSelectedMilestone] = useState("");
  const [patientData, setPatientData] = useState({});
  const [patientId, setPatientId] = useState("");
  const [validated, setValidated] = useState(false);
  const { session, user } = useSession();
  const [availableMilestones, setAvailableMilestones] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const resetAndRedirect = () => {
    const currentPathname = window.location.pathname;
    const currentSearch = window.location.search;
    const currentState = window.history.state;
  
    const result = State.setValue(LoginFlowState.REDIRECT_AFTER_LOGIN, {
      pathname: currentPathname,
      search: currentSearch,
      state: currentState,
    });
  
  
    clearSession();
  
    navigate("/");
  };

  useEffect(() => {
    const getPatientUserData = async (participantId) => {
      console.log("[ConsentUpToDate] ParticipantId:", participantId);
  
      const response = await QrController.getQrScanDetails(participantId);
      console.log("[ConsentUpToDate] Scan details response:", response);
  
      if (!response?.success || !response.patient) {
        console.warn("[ConsentUpToDate] Scan details failed or no patient:", response);
        navigationService.navigateTo("/qr-scan-failed");
        return;
      }
  
      const patient = response.patient;
      console.log("[ConsentUpToDate] Patient data:", patient);
  
      const status = patient.consentStatus?.toLowerCase();
      console.log("[ConsentUpToDate] Consent Status:", status);
  
      if (["revoked", "withdraw", "drop_out"].includes(status)) {
        navigationService.navigateTo("/qr-scan-failed");
        return;
      }
  
      if (status === "pending") {
        navigate("/consent-outdated", {
          state: {
            patientData: {
              firstname: patient.patientName?.split(" ")[0] || "",
              lastname: patient.patientName?.split(" ").slice(1).join(" ") || "",
              participantId: patient.participantId,
              studyId: patient.studyId,
              email: patient.email,
            },
            lastAction: {
              description: `Consent outdated - Patient must reconsent`,
              date: new Date().toLocaleString("en-US", {
                dateStyle: "short",
                timeStyle: "short",
              }),
            },
          },
        });
        return;
      }
  
      setPatientData({
        firstname: patient.patientName?.split(" ")[0] || "",
        lastname: patient.patientName?.split(" ").slice(1).join(" ") || "",
        participantId: patient.participantId,
        studyId: patient.studyId,
      });
      setPatientId(patient.participantId);
  
      const milestones = await ParticipantController.getMilestonesForParticipant(patient.participantId);
      console.log("[ConsentUpToDate] Milestones:", milestones);
  
      if (milestones?.success !== false) {
        setAvailableMilestones(milestones);
      }
    };
  
    if (session === undefined) return;
  
    if (!user || user.role !== "investigator") {
      if (!STATE[REDIRECT_AFTER_LOGIN]) {
        resetAndRedirect();
      }
      return;
    }
  
    const participantId = new URLSearchParams(window.location.search).get("participant_id");
    console.log("[ConsentUpToDate] participant-id from URL:", participantId);
  
    if (participantId) {
      getPatientUserData(participantId);
    } else {
      resetAndRedirect();
    }
  }, [user, session]);
  /** ------------------ cmt 943835 ------------------
  Ancien code qui recupere les data avec userId 
  *-------------------------------------------------*/
  /* useEffect(() => {
    const getPatientUserData = async (uId) => {
      const patientUserData = await UserController.getUserInfo(uId);
      console.log(
        "=== patientUserData === ConsentToUpDate.jsx === key: 910812 ==="
      );
      console.dir(patientUserData, { depth: null, colors: true });
      console.log("=================================");
      if (patientUserData.success === false) {
        navigationService.navigateTo("/qr-scan-failed");
      }
      patientUserData.id = uId;
      setPatientData(patientUserData);
      setPatientId(uId);

      if (patientUserData?.participantData?.participant_id) {
        const milestones =
          await ParticipantController.getMilestonesForParticipant(
            patientUserData?.participantData?.participant_id
          );
        console.log(
          "=== milestones === ConsentToUpDate.jsx === key: 672925 ==="
        );
        console.dir(milestones, { depth: null, colors: true });
        console.log("=================================");
        if (milestones?.success !== false) {
          setAvailableMilestones(milestones);
        }
      }
    };
    console.log("=== user === ConsentToUpDate.jsx === key: 573303 ===");
    console.dir(user, { depth: null, colors: true });
    console.log("=================================");
    if (!user || user.role !== "investigator") {
      resetAndRedirect();
    }
    //recupération le userId dans l'url via ?userId =
    const patientUserId = new URLSearchParams(window.location.search).get("participant-id");
    console.log(
      "=== patientUserId === ConsentToUpDate.jsx === key: 910812 ==="
    );
    console.dir(patientUserId, { depth: null, colors: true });
    console.log("=================================");

    if (patientUserId) {
      getPatientUserData(patientUserId);
    } else {
      resetAndRedirect();
    }
  }, []); */

  

  const handleValidate = async (e) => {
    e.preventDefault();
  
    if (selectedMilestone) {
      setIsLoading(true);
  
      const milestone = availableMilestones.find(
        (milestone) => milestone.id === selectedMilestone
      );
  
      const payload = {
          participantId: patientData.participantId,
          studyId: patientData.studyId,
          milestoneIndex: milestone.milestone_index,
          milestoneId: milestone.id,
          siteId: milestone.site_id,
          eventTimestamp: Date.now(),
          status: "checked",
          checkingType: "qr_code",
        };
      
  
      try {
        const addParticipantMilestoneRes = await ParticipantController.addParticipantMilestone(payload);
        console.log("📩 Reponse backend:", addParticipantMilestoneRes);
  
        console.log('=== addParticipantMilestoneRes === ConsentToUpDate.jsx === key: 385183 ===');
        console.dir(addParticipantMilestoneRes, { depth: null, colors: true });
        console.log('=================================');
  
        setValidated(true);
        setIsLoading(false);
        navigate("/milestone-logged", {
          state: {
            patientData: {
              firstname: patientData.firstname,
              lastname: patientData.lastname,
              participantId: patientData.participantId,
            },
            lastAction: {
              description: `Milestone ${milestone.milestone_index} - ${milestone.title} completed by the patient`,
              date: new Date().toLocaleString("en-US", {
                dateStyle: "short",
                timeStyle: "short",
              }),
              previousActions: [],
            },
          },
        });
      } catch (error) {
        console.error("❌ Error during milestone validation:", error);
        setIsLoading(false);
        navigate("/milestone-error", {
          state: {
            patientData: {
              firstname: patientData.firstname,
              lastname: patientData.lastname,
              participantId: patientData.participantId,
            },
            lastAction: {
              description: `Milestone ${milestone.milestone_index} - ${milestone.title} attempted but failed`,
              date: new Date().toLocaleString("en-US", {
                dateStyle: "short",
                timeStyle: "short",
              }),
            },
          },
        });
      }
    } 
  };
    
  const handleCancel = () => {
    window.close();
  };

  return (
    <VerificationLayout title="Verification - Up to Date">
      <StatusBox
        type="success"
        title="Consent up to date"
        message="The patient's informed consent is valid and up to date."
      />

<PatientDetails patient={patientData} lastAction={patientData?.lastAction} />

      <div className="mt-6 mb-6">
        <p>
          Please select the current milestone and confirm the entry on the
          application.
        </p>
      </div>

      <div className="mb-6">
        <label className="block text-sm font-medium mb-2">
          Select the relevant milestone
        </label>
        <select
          value={selectedMilestone}
          onChange={(e) => setSelectedMilestone(e.target.value)}
          className="w-full px-3 py-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Milestone</option>
          {availableMilestones.map((milestone) => (
            <option
              key={milestone.id}
              value={milestone.id}
              disabled={milestone.executed}
            >
              {milestone.title + " -  " + milestone.short_description}
            </option>
          ))}
        </select>
      </div>

      <div className="flex justify-between mt-8">
        <Button
          onClick={handleCancel}
          variant="QrCoderounded"
          className=" mr-8"
          disabled={isLoading}
        >
          Cancel
        </Button>

        <Button
          onClick={handleValidate}
          variant="QrCoderounded"
          disabled={!selectedMilestone || isLoading}
          className=" "
        >
          {isLoading ? (
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          ) : (
            "Validate"
          )}
        </Button>
      </div>
    </VerificationLayout>
  );
}